import { useState } from "react";
import { Link } from "react-router-dom";
import { api, apiError } from "@/lib/api";
import { Navbar } from "@/components/Navbar";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { KeyRound, MailCheck } from "lucide-react";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true); setErr("");
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (e2) {
      setErr(apiError(e2.response?.data?.detail) || e2.message);
    } finally { setLoading(false); }
  };

  return (
    <div className="App">
      <Navbar />
      <div className="mx-auto flex max-w-md flex-col px-6 py-16">
        {sent ? (
          <div data-testid="forgot-sent" className="rounded-2xl border border-sugar-border bg-white p-8 text-center sugar-card-shadow">
            <span className="mx-auto grid h-14 w-14 place-items-center rounded-2xl bg-sugar-blush text-sugar-pink"><MailCheck size={26} /></span>
            <h1 className="mt-4 font-display text-2xl font-extrabold text-sugar-ink">Check your email</h1>
            <p className="mt-2 text-sm text-sugar-ink2">If an account exists for <span className="font-semibold">{email}</span>, we've sent a link to reset your password. It expires in 1 hour.</p>
            <Link to="/login" className="mt-6 inline-block font-bold text-sugar-pink">Back to log in</Link>
          </div>
        ) : (
          <>
            <div className="mb-8 text-center">
              <span className="mx-auto grid h-14 w-14 place-items-center rounded-2xl bg-sugar-pink text-white"><KeyRound size={26} /></span>
              <h1 className="mt-4 font-display text-3xl font-extrabold text-sugar-ink">Forgot password?</h1>
              <p className="mt-1 text-sm text-sugar-ink2">Enter your email and we'll send you a reset link.</p>
            </div>
            <form onSubmit={submit} className="space-y-4 rounded-2xl border border-sugar-border bg-white p-7 sugar-card-shadow">
              {err && <p data-testid="forgot-error" className="rounded-lg bg-red-50 px-3 py-2 text-sm font-medium text-red-600">{err}</p>}
              <div>
                <label className="mb-1.5 block text-sm font-bold text-sugar-ink">Email</label>
                <Input data-testid="forgot-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="rounded-xl border-sugar-border" />
              </div>
              <Button data-testid="forgot-submit" disabled={loading} type="submit" className="w-full rounded-full bg-sugar-pink py-6 font-bold text-white hover:bg-sugar-pinkhover">
                {loading ? "Sending..." : "Send reset link"}
              </Button>
              <p className="text-center text-sm text-sugar-ink2">
                Remembered it? <Link data-testid="forgot-to-login" to="/login" className="font-bold text-sugar-pink">Log in</Link>
              </p>
            </form>
          </>
        )}
      </div>
    </div>
  );
}
